// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2749":"0a59f75f","3607":"0a59f75f","7796":"d0d55ec6"}[chunkId] + ".chunk.css";
};